import { Component, OnInit, Input, Output,
         EventEmitter, ViewChild } from '@angular/core';

import {INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'event-form-modal',
  templateUrl: './event-form-modal.component.html',
  styleUrls: ['./event-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class EventFormModalComponent implements OnInit {
  @ViewChild('previewImg') previewImg;

  @Input()  selectedEvent: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  event = {
    title: "",
    description: "",
    startingTimestamp: new Date().getTime(),
    endingTimestamp: new Date().getTime(),
    location: "",
    city: "",
    state: ""
  };

  dpOptions = {
    dateFormat: 'mm.dd.yyyy'
  }

  uploadedFile: File;

  constructor(private dbService: DBService) { }

  ngOnInit() {
    if (this.selectedEvent) {
      this.event = this.selectedEvent;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {

    if (this.selectedEvent) {
      console.log(this.selectedEvent);
      this.dbService.updateEvent(this.selectedEvent.$key,
                                 this.event,
                                 this.uploadedFile);
    } else {
      this.dbService.addEvent(this.event, this.uploadedFile);
    }

    this.onHideModal();
  }

  onStartDtChanged(date) {
    console.log(date);
    this.event.startingTimestamp = date.epoc * 1000;
  }

  onEndDtChanged(date) {
    console.log(date);
    this.event.endingTimestamp = date.epoc * 1000;
  }

  onFileChange(event) {
    let file = event.target.files[0];
    let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);
    this.uploadedFile = file;

  }

}



// WEBPACK FOOTER //
// ./src/app/calendar/event-form-modal/event-form-modal.component.ts